import { css } from '@emotion/css'
import getThemeColors, { colors } from '../../../themes'
import { fontFamily, fontSize, fontWeight, spacing } from '../../../styles'

const styles = {
  button: css({
    background: 'none',
    backgroundColor: colors.white,
    border: 'none',
    color: colors.jumbo,
    fontFamily: fontFamily.body,
    fontWeight: fontWeight.normal,
    fontSize: fontSize.default,
    padding: spacing.default,
    textAlign: 'left',
    whiteSpace: 'nowrap',
    width: '100%',
    cursor: 'pointer',
    margin: 0,

    '&:hover, &:focus': {
      outline: 'none',
    },
  }),
}

export const buttonTheme = theme => {
  const themed = getThemeColors(theme)
  const base = theme === 'light' ? colors.jumbo : themed.base

  return css({
    '&:hover, &:focus': {
      backgroundColor: themed.light,
      color: base,
    },
  })
}

export default styles
